import React, { useEffect } from 'react';
import NumberPicker from '@/common/number-picker';
import SkuStore from '@/stores/sku';
import NoticeStore from '@/stores/notice';
import Notice from '../module_actions/notice';
import Price from '@/component/module_actions/price';
import Total from '@/component/module_actions/total';
import Express from '@/component/module_actions/express';
interface AvailableActivity {
  activityId: number;
  endTime: number;
  hasLimit: boolean;
  limitCount: number;
  promotionContent: string;
  startTime: number;
  status: string;
}
// 无限库存设为一个非常大的值，或者根据业务需求设定
const INFINITE_STOCK = 999999999;
export default function none(props: {
  showType?: string;
  i18n: DetailTypes.i18n;
  children?: React.JSX.Element;
  skuAttrs: SkuTypes.SkuAttr[];
  price: PriceTypes.Root;
  inventory: InventoryTypes.Root;
  skuInfoMap: InventoryTypes.SkuInfoMap;
  // 区分页面和弹窗不同组件入口
  moduleName: string;
  sampleInfo: SampleTypes.Root;
  type: SkuTypes.TypeInfo;
  moq: number;
  renderConfig: DetailTypes.renderConfig<{
    showType: string;
  }>;
  visitCountry: string;
  productId: number;
  hasLogistics: boolean;
  productIsMarketGoods: boolean;
  sourcingTradeAvailable: boolean;
  isDispatchGuaranteed: boolean;
  abtest: DetailTypes.Abtest;
  availableActivity: AvailableActivity;
}) {
  const { moq, inventory, showType, i18n, price, children, availableActivity } = props;
  const { batchNum = 1, unitEven, unit } = price;

  const { preferedDispatchId, repoSkuInventory, defaultDispatchId } = inventory;
  const skuInventory = repoSkuInventory[preferedDispatchId] || repoSkuInventory[defaultDispatchId];

  const skuStore = SkuStore((state) => state);
  const { setNoneQuantity, setNoneSku, setTotalPrice } = skuStore;
  const { quantity, isSoldOut } = skuStore.product;
  const noticeStore = NoticeStore((state) => state);
  const { inventoryCount = INFINITE_STOCK } = skuInventory.skuMap[-1] || {};

  // 营销活动限购数量
  const limitCount = availableActivity?.limitCount;
  // 是否走营销活动限购逻辑
  const isLimitCount = limitCount && limitCount <= inventoryCount;

  useEffect(() => {
    setNoneSku({
      type: 'product',
      inventoryMap: skuInventory,
    });
    setTotalPrice({
      type: 'product',
      rule: price,
      moq,
    });
  }, []);

  /** 库存提示文案
   *  moq>库存  出out of stock
      moq <=5，moq<=库存 <=15 出only xx left 
      moq > 5, 库存/moq <=2  出only xx left 
   */
  const renderInventoryInfo = () => {
    if (inventoryCount === 0) {
      return <div className="inventory-info out-of-stock">{i18n['notice.content.wuhan']}</div>;
    }
    // 库存紧张的判断逻辑
    const isTightStock =
      inventoryCount > 0 &&
      ((moq <= 5 && inventoryCount <= 15) || (moq > 5 && inventoryCount / moq <= 2));

    if (isTightStock) {
      const inventoryUnit = inventoryCount > 1 ? unitEven : unit;
      const message = i18n['detail_detail_stock_less_stock_left']
        ?.replace('{0}', inventoryCount)
        ?.replace('{1}', inventoryUnit);
      return <div className="inventory-info tight-stock">{message}</div>;
    }

    return null;
  };

  // 无sku商品的库存取数逻辑
  let maxInventory = inventoryCount;
  // 无限库存
  if (inventoryCount === -1) {
    maxInventory = INFINITE_STOCK;
  } else if (isLimitCount) {
    maxInventory = limitCount;
  }

  return (
    <div className="sku-layout none">
      <h3>{i18n['detailModule.supplyAbility.quantity']}</h3>
      <div className="sku-option">
        <NumberPicker
          value={quantity}
          style={{
            width: 120,
          }}
          onChange={(number) => {
            setNoneQuantity(number);
            setTotalPrice({
              type: 'product',
              rule: price,
              moq,
            });
            // 当商品限购时出限购提示
            if (isLimitCount && number >= maxInventory) {
              return noticeStore.modify(
                i18n['sku_purchase_limit_tips'].replace(
                  '{0}',
                  limitCount + ' ' + (limitCount > 1 ? unitEven : unit),
                ),
              );
            }
            // 当商品加到最大库存时出提示
            if (number === inventoryCount) {
              noticeStore.modify(
                i18n['detail_sku_availablestock_tips'].replace(
                  '{0}',
                  inventoryCount + ' ' + (inventoryCount > 1 ? unitEven : unit),
                ),
              );
            }
          }}
          onMaxQuantity={() => {
            if (isSoldOut) return noticeStore.modify(i18n['detail_sku_soldout_tips']); // 手动输入触发
            // 当商品限购时出限购提示
            if (isLimitCount && quantity >= maxInventory)
              return noticeStore.modify(
                i18n['sku_purchase_limit_tips'].replace(
                  '{0}',
                  limitCount + ' ' + (limitCount > 1 ? unitEven : unit),
                ),
              );
            noticeStore.modify(
              i18n['detail_sku_availablestock_tips'].replace(
                '{0}',
                maxInventory + ' ' + (maxInventory > 1 ? unitEven : unit),
              ),
            );
          }}
          min={0}
          step={batchNum}
          max={maxInventory}
        />
      </div>
      {/* 出库存提示 */}
      {renderInventoryInfo()}
      {children}
      <div className="sku-out-bottom">
        <Price {...props} />
        <Express {...props} />
        <Total {...props} />
        {showType !== 'quick' && (
          <Notice
            style={{
              top: '0px',
            }}
          />
        )}
      </div>
    </div>
  );
}
